import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import { Container } from "semantic-ui-react";
import { ISessionState, SESSION_EVENTS } from "src/reducers/session";
import { withAuthorization } from "../../components/Session/withAuthorization";
import Welcome from "./Welcome";

interface IJoinComponent {
  session: ISessionState;
  history: any;
  match: any;
  location: any;
  onSetWelcomeMsg: (show: boolean) => void;
}

const JoinComponent = ({
  session,
  history,
  location,
  match,
  onSetWelcomeMsg,
}: IJoinComponent) => (
  <React.Fragment>
    <Container className="main-container">
      <Welcome
        authUser={session.authUser}
        orgId={session.orgId}
        location={location}
        history={history}
        match={match}
        onSetWelcomeMsg={onSetWelcomeMsg}
      />
    </Container>
  </React.Fragment>
);

const mapStateToProps = (state: any) => ({
  session: state.sessionState,
});

const authCondition = (authUser: any) => !!authUser;

const mapDispatchToProps = (dispatch: any) => ({
  onSetWelcomeMsg: (show: boolean) =>
    dispatch({
      type: SESSION_EVENTS.WELCOME_MSG_SET,
      show,
    }),
});

const Join = compose(
  withAuthorization(authCondition),
  connect(mapStateToProps, mapDispatchToProps)
)(withRouter(JoinComponent));

export default Join;



// WEBPACK FOOTER //
// ./src/containers/Join/index.tsx